const fns = (() => {
	return {
		dataURLtoBlob: (dataurl) => {
			// console.log({dataurl});
			if (dataurl != "data:") {
				var arr = dataurl.split(","),
					matches = arr[0].match(/:(.*?);/),
					mime = matches?.length > 0 ? matches[1] : undefined,
					bstr = arr?.length > 0 ? atob(arr[1]) : "",
					n = bstr ? bstr.length : 0,
					u8arr = new Uint8Array(n);
				while (n--) {
					u8arr[n] = bstr.charCodeAt(n);
				}
				return new Blob([u8arr], {type: mime});
			} else return new Blob();
		},

		//**blob to dataURL**
		blobToDataURL: (blob, callback) => {
			var a = new FileReader();
			a.onload = function (e) {
				if (callback) callback(e.target.result);
			};
			a.readAsDataURL(blob);
		},
	};
})();

export default fns;
